var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoneyFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.155 17.445h.126c1.26 0 2.135-.783 2.135-1.903 0-1.28-1.107-1.864-2.135-1.864h-.127v3.767ZM11.635 8.406h-.092c-1.26 0-2.136.783-2.136 1.903 0 1.28 1.107 1.864 2.136 1.864h.092V8.406Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.378 24.892c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12ZM11.635 5.35h1.52v1.538h.132a3.669 3.669 0 0 1 3.662 3.661l-.007-.007h-1.519c0-1.18-.962-2.135-2.136-2.135h-.133v3.753h.127c2.122 0 3.661 1.426 3.661 3.383 0 1.956-1.572 3.422-3.661 3.422h-.127v1.426h-1.519v-1.426h-.099a3.669 3.669 0 0 1-3.662-3.661h1.52c0 1.18.961 2.135 2.135 2.135h.106v-3.746h-.092c-2.123 0-3.662-1.426-3.662-3.383 0-1.956 1.572-3.422 3.662-3.422h.092V5.35Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MoneyFilled.3acb473dd578f5d2359fa36a66334b72.svg";